import { render, staticRenderFns } from "./bettingRobots.vue?vue&type=template&id=6c1de68f"
import script from "./bettingRobots.vue?vue&type=script&lang=js"
export * from "./bettingRobots.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports